export const SUPPRESS_EVENT: { emitEvent: boolean } = { emitEvent: false };
